module.exports = __webpack_public_path__ + "static/img/QRcode.99d61c99.png";